import TipoAcionadoService from './../_services/TipoAcionadoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { tipoAcionadoModel } from './../_model/tipoAcionado'

const state = {
  loading: false,
  loadingStore: false,
  dropdownTipoAcionado: [],
  tipoAcionados: [],
  tipoAcionadoSelecionado: undefined,
  erros: '',

}

const getters = {
  GET_TIPOACIONADOS : (state) => state.tipoAcionados,
  GET_DROPDOWN: state => state.dropdownTipoAcionado,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  TIPOACIONADO_SELECTED : (state, { tipoAcionado }) => {
    state.tipoAcionadoSelecionado = Object.assign({}, tipoAcionado)
  },

  SET_TIPOACIONADOS : (state, { tipoAcionados }) => {
    state.tipoAcionados = JSON.parse(JSON.stringify(tipoAcionados))
  },

  SET_DROPDOWN : (state, tipoAcionados) => {
    state.dropdownTipoAcionado = JSON.parse(JSON.stringify(tipoAcionados))
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.tipoAcionadoSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await TipoAcionadoService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = []
        var obj = response.data.tipo_acionados
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].ds_tipoacionado}
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_TIPOACIONADOS : async ({ commit }) => {
      commit('SET_TIPOACIONADOS', { tipoAcionados : []})
      commit('ERASE_ERROS')
      await TipoAcionadoService.getTipoAcionados()
      .then(response => {
        if (response.data.status) {
          commit('SET_TIPOACIONADOS', { tipoAcionados : response.data.tipo_acionados })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_TIPOACIONADO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await TipoAcionadoService.getTipoAcionado(id)
    .then(response => {
      if (response.data.status) {
        commit('TIPOACIONADO_SELECTED', { tipoAcionado : response.data.tipo_acionado })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_TIPOACIONADO : async ({ commit, dispatch }, tipoAcionado) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!tipoAcionado.id || !(tipoAcionado.id > 0)) { 
        var response = await TipoAcionadoService.postTipoAcionado(tipoAcionado)
      } else {
        var response = await TipoAcionadoService.putTipoAcionado(tipoAcionado.id, tipoAcionado)
      }

      if (response.data.status) {
        commit('TIPOACIONADO_SELECTED', { tipoAcionado : response.data.tipo_acionado })
          await dispatch('GET_TIPOACIONADOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_TIPOACIONADO : async ({ commit, dispatch }, usuario) => {
    commit('ERASE_ERROS')
    try {
      var response = await TipoAcionadoService.deleteTipoAcionado(usuario.id)

      if (response.data.status) {
        await dispatch('GET_TIPOACIONADOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  TIPOACIONADO_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_TIPOACIONADO', id)
    } else {
      var obj = new tipoAcionadoModel.tipoAcionado()
      await commit('TIPOACIONADO_SELECTED', { tipoAcionado: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/TipoAcionado/_store/index.js